import { Component, OnInit, Input } from '@angular/core';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'user-navbar',
  templateUrl: './user-navbar.component.html',
  styleUrls: ['./user-navbar.component.css']
})
export class UserNavbarComponent implements OnInit {

 
  @Input("showNavbar")showNavbar :boolean = false  ;
  @Input("userId") userId:number ;
  @Input ("userName")userName:string ;  
  
  constructor(private user:UsersService ) 
  {
    this.showNavbar = this.user.showNavbar ;
    this.userName = this.user.userName ;
    
   }

  ngOnInit() {

    this.showNavbar = this.user.showNavbar ;
    this.userName = this.user.userName ;
   
  }

}
